import { render } from "./DashboardCampaignsDonated.vue?vue&type=template&id=7875c808"
import script from "./DashboardCampaignsDonated.vue?vue&type=script&lang=js"
export * from "./DashboardCampaignsDonated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__